<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <h4>短訊管理</h4>
            <h5>當前管理員: {{username}}</h5>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <b-tabs v-model="tabIndex" content-class="mt-3" justified>
          <b-tab title="Reconnect to customer" active>
            <FITSelect :rule="{required:true}" :width="9" label="Select User by Criteria" v-model="filter.customerType" :options="customerTypeList"></FITSelect>

            <b-row class="FITSelect" align-v="center">
              <b-col :sm="3" class="text-left">
                 <label  class="mb-0 align-middle">Store Information</label>
              </b-col>
              <b-col :sm="9">
                <el-select
              v-model="filter.storeID"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="Please enter a keyword"
              :remote-method="remoteMethod"
              :loading="loading">
              <el-option
                v-for="item in storeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
              </b-col>
            </b-row>

            <b-row class="FITSelect" align-v="center">
              <b-col :sm="12" class="text-left">
                <label class="mb-0 align-middle">Message (format: 1.Store Name: {{ encoded.name }} 2.Store Telephone : {{encoded.phone}} 3. Store Address: {{encoded.address}} 4. District of Store : {{encoded.district}} )</label> 
                <b-button variant="primary" size="md" @click="previewMessage" style="margin-left:1rem;">Preview Message</b-button>
                <b-button variant="success" size="md" @click="sendMessage" style="margin-left:1rem;">Send Message</b-button>

              </b-col>
            </b-row>
            <b-row class="FITSelect" align-v="center" style="margin-top:1rem;">
              <b-col :sm="12" class="text-left">
                <b-form-textarea
                  id="textarea"
                  v-model="message"
                  placeholder="Enter something..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-col>
            </b-row>

          </b-tab>
          <b-tab title="Tailor-made SMS">
            <p>Recipient List <b-button variant="primary" size="md" @click="previewPhoneNumber" style="margin-left:1rem;">Preview Phone Number</b-button></p>
            <b-row class="FITSelect" align-v="center" style="margin-top:1rem;">
              <b-col :sm="12" class="text-left">
                <el-select
                  v-model="phoneArray"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  placeholder="Choose tags for your article">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </b-col>
            </b-row>
            <p style="margin-top:1rem;">Message <b-button variant="success" size="md" @click="sendTailorMessage" style="margin-left:1rem;">Send Message</b-button></p>
            <b-row class="FITSelect" align-v="center" style="margin-top:1rem;">
              <b-col :sm="12" class="text-left">
                <b-form-textarea
                  id="textarea"
                  v-model="message"
                  placeholder="Enter something..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-col>
            </b-row>
            </b-tab>
        </b-tabs>
      </div>
    </FITFormCard>
      <div>
  <!-- <b-button >Launch demo modal</b-button> -->

  <b-modal v-model="modalShow"  title="創建/更改商店資料"  @ok="modelSubmit">
    <div style="padding-left:15px; padding-right: 15px; ">
    <FITTextInput :width="9"  label="商舖ID" :disabled="true" v-model="storeForm.ID" v-if="storeForm.ID"></FITTextInput>
    <FITSelect :rule="{required:true}" :width="9" label="商戶編號" v-model="storeForm.accountID" :options="merchantList"></FITSelect>
    <FITCheckbox v-model="showCreateMerchant"></FITCheckbox><span class="text-danger font-weight-bold">(如無商戶編號請先新增商戶編號)</span>
    <div v-if="showCreateMerchant">
    <FITTextInput :rule="{minLength:6, maxLength:6, required: true, numeric:true}" :width="9"  v-model="merchantForm.username" ></FITTextInput>
    <b-button  variant="success" size="md" @click="createMerchant">新增商戶</b-button>
  </div>
      <FITTextInput :rule="{required:true}" :width="9"  label="商舖名稱" v-model="storeForm.name"></FITTextInput>
    <FITSelect @input="resetDistrict()" :rule="{required:true}" :width="9" label="地區" v-model="selectedRegion" :options="this.selections.region"></FITSelect>
    <FITSelect  :rule="{required:true}" :disabled="!selectedRegion"  :width="9" label="地點" v-model="storeForm.parentKey" :options="this.updatedDistrictList"></FITSelect>

    <FITTextInput :rule="{required:true}" :width="9"  label="商舖地址" v-model="storeForm.address"></FITTextInput>
    <span class="text-default">座標查詢網址：<a href="https://www.latlong.net/" target="_blank">https://www.latlong.net/</a></span>
    <FITTextInput :rule="{required:true}" :width="9"  label="座標Lat" v-model="storeForm.latitude"></FITTextInput>
    <FITTextInput :rule="{required:true}" :width="9"  label="座標Long" v-model="storeForm.longitude"></FITTextInput>

    <FITTextInput :rule="{minLength:8, maxLength:8, numeric:true, required:true}" :width="9"  label="聯絡電話" v-model="storeForm.telephone"></FITTextInput>
    <FITTextInput :rule="{minLength:8, maxLength:8, numeric:true}" :width="9"  label="SMS電話號碼" v-model="storeForm.smsPhone"></FITTextInput>
    <FITSelect :width="9"  label="近視/遠視" v-model="storeForm.short" :options='productOption'></FITSelect>
    <FITSelect :width="9"  label="散光" v-model="storeForm.light" :options='productOption'></FITSelect>
    <FITSelect :width="9"  label="漸進" v-model="storeForm.axis" :options='productOption'></FITSelect>
</div>
  </b-modal>
</div>
  </div>

</template>
<script type="text/javascript">


const selectionInitial = {
    gender: [],
    brand: [],
    product: [], // With parentKey
    lens: [],
    degree: [], // With parentKey
    region: [],
    district: [], // With parentKey
    store: [], // With parentKey
    productType:[],
};

const storeFormInitial = {
    "ID": '',
    // "type": "store",
    "accountID": '',
    "name": '',
    "region": '',
    "district": '',
    "parentKey": '',
    "address": '',
    "telephone": '',
    "smsPhone": '',
    "short": '',
    "light": '',
    "axis": '',
    "latitude":'',
    "longitude":'',
};

import { FITSearchableTable, FITFormCard, FITTextInput, FITSelect, FITCheckbox } from '@/components'
import $ from 'jquery'
import Cookies from 'js-cookie'

export default {
  name: 'SMSBatch',
  props: {},
  components: {
    FITSearchableTable,
    FITFormCard,
    FITTextInput,
    FITSelect,
    FITCheckbox
  },
  created(){

        this.getAllStoreList();

        // this.getAllSelections('storeList');
        // console.log(this.selections)
  },

  data(){
  	return{
      tabIndex:1,
      loading:false,
      placeholder:'Region / District / Telephone / Name',
      selections:{},
      filters:[],
      filter:{
        customerType:"A",
        storeID:[],
      },
      storeOptions:[],
      allStoreOptions:[],
      pagination:{
        page:1,
        count:100,
      },
      merchantList:[],
      customerTypeList:[
        {value:'A',text:"All User"},
        {value:1,text:"All Registered User"},
        {value:2,text:"All Redeemed User"},
        {value:3,text:"Registered but didn't redeem"},
        {value:4,text:"Registered but expired"}
      ],
      encoded:{
        name:"{{name}}",
        phone:"{{phone}}",
        address:"{{address}}",
        district:"{{district}}"
      },
      modalShow:false,
      storeForm:{},
      selectedRegion:"",
      showCreateMerchant:false,
      merchantForm:{
        username:'',
      },
      productOption:[
        {value:"", text:'-'},
        {value:"Y", text:'Y'},
      ],
      options:[],
      message:"",
      phoneString:"",
      phoneArray:[],
  	}
  },
  watch:{
    // selectedRegion:function(newVal){
    //   this.storeForm.parentKey = "";
    // }
  },
  computed:{
    updatedDistrictList(){
      if(!this.selectedRegion) return [];
      let districtList = [];
      this.selections.district.forEach((district)=>{
        if(district.parentKey == this.selectedRegion){
          districtList.push(district);
        }
      })
      // console.log(districtList)
      return districtList;
    },
    permissionLevel() {
      return Cookies.get('permissionLevel');
    },
    username() {
      return Cookies.get('username');
    },
    updatedColumns(){
      let columns = this.columns;
      let ignoreColumns = [
      'informationFlag',
      'emailFlag',
      'smsFlag'
      ];
      let columnIndex= 0;
      if(this.permissionLevel >3.5){
        $.each(columns,(index,value)=>{
          if(value.key == 'informationFlag')
          {
             columnIndex = index ;
          }
        });
        columns.splice(columnIndex,3);    
      }
      return columns;
    }
  },
  methods:{

    remoteMethod(query) {
      let dummyArray = [];
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            if(query == ''){
              this.storeOptions = this.allStoreOptions;
            }
            else{
              this.$store.dispatch('Homepage/getFinalStoreList', {criteria:query,page:1,count:100}).then((json) => {
              this.storeOptions = json.data.list.map((obj) => {
                return{
                  label:obj.name,
                  value:obj.ID
                }
              })
              })
            }
          }, 500);
    },

    getAllStoreList(){
      this.$store.dispatch("Homepage/getFinalStoreList", {page:1,count:100}).then((json) => {
        this.allStoreOptions = json.data.list.map((obj) => {
          return{
            label:obj.name,
            value:obj.ID
          }
        })
        this.storeOptions = this.allStoreOptions;
      })
    },

    previewMessage(){
      let param = {};
      if(this.message == "" || this.message == null){
        alert("The message cannot be empty.")
        return;
      }
      else{
        param.message = this.message
      }
      if(this.filter.customerType != 'A'){
        param.customerType = this.filter.customerType
      }
      else{
        param.customerType = null
      }
      if(this.filter.storeID.length!=0){
        param.storeID = this.filter.storeID;
      }
      else{
        param.storeID = null;
      }
      this.$store.dispatch("Homepage/previewMessage",param).then((json) => {
        if(json.status == 200){
          alert(json.data.message);
        }
        else{
          alert(json.message);
        }
      }).catch((error) => {
        console.error(error)
      })
    },

    sendMessage(){
      let param = {};
      if(this.message == "" || this.message == null){
        alert("The message cannot be empty.")
        return;
      }
      else{
        param.message = this.message
      }
      if(this.filter.customerType != 'A'){
        param.customerType = this.filter.customerType
      }
      else{
        param.customerType = null
      }
      if(this.filter.storeID.length!=0){
        param.storeID = this.filter.storeID;
      }
      else{
        param.storeID = null;
      }
      this.$store.dispatch("Homepage/reconnectCustomer",param).then((json) => {
        if(json.status == 200){
          alert(json.data.message);
          this.message = ""
          this.filter = {
            customerType:"A",
            storeID:[]
          }
        }
        else{
          alert(json.message);
        }
      }).catch((error) => {
        console.error(error)
      })
    },

    previewPhoneNumber(){
      let paramArray = this.phoneArray;
      let errorMessage = "";
      for(var i=0;i<paramArray.length;i++){
        if(paramArray[i].length!=8){
          if(i == 0){
            errorMessage = errorMessage + "The 1st ,"
          }
          else if (i == 1){
            errorMessage = errorMessage + "2nd"
          }
          else if (i == 2){
            errorMessage = errorMessage + "3rd"
          }
          else{
            errorMessage = errorMessage + `${i+1}th `
          }
          errorMessage = errorMessage + "element is/are not correct, The phone number should be 8-digit."
        }
      }
      if(errorMessage != ""){
        alert(errorMessage)
      }
      else{
        alert("The Phone number are" + paramArray.join(','))
      }
    },

    sendTailorMessage(){
      let phone = this.phoneArray;
      let errorFlag = 1;
      if(paramArray.length == 0)
      errorFlag = 0;
      for(var i=0;i<paramArray.length;i++){
        if(paramArray[i].length!=8){
          errorFlag = 0;
          return;
        }
      }
      if(errorFlag == 0){
        alert("The phone number is not correct.")
      }
      else if (this.message == ""){
        alert("The message cannot be empty.")
      }
      else{
        this.$store.dispatch("Homepage/tailorMessage",{message:this.message,phone:phone}).then((json) => {
          alert(json.message);
        }).catch((err) => {
          console.error(err)
          alert(err);
        })
      }
    },



    resetDistrict(){
      this.storeForm.parentKey = '';
    },
    initCreateModal(){
      this.modalShow = !this.modalShow;
      this.storeForm = storeFormInitial;
      this.selectedRegion = '';
      this.merchantForm.username = '';
      this.showCreateMerchant = false;
    },

    modelSubmit(bvModalEvt){
        bvModalEvt.preventDefault()
      let formData = this.storeForm;

      if(!confirm('確認提交新增/修改商鋪資料？')){
        return;
      }

      
      // Convert ParentKey to Region and district
      this.selections.region.forEach((region)=>{
        if(this.selectedRegion == region.value){
          formData.region = region.text;
        }
      });
      this.selections.district.forEach((item)=>{
        if(formData.parentKey == item.value){
          formData.district = item.text;
        }
      });

      if((!formData.region)||(!formData.district)||(!formData.name)||(!formData.address)||(!formData.telephone)||(!formData.latitude)||(!formData.longitude)){
        alert("請填妥商店資料再重新提交。");
        return;
      }

      if(formData.ID){
        // Edit Store
        this.$store.dispatch('Homepage/updateFinalStore', formData).then((json)=>{
          
          if(json.status != 200){
            alert(json.message)
          }else{
            // this.$store.dispatch('Homepage/getStoreList',this.pagination);
            this.$refs.storeList.search(this.pagination)
            this.storeForm = storeFormInitial;
            this.modalShow = false;          
            }
        })

      }else{
        // Create Store
        delete formData["ID"];
        // delete formData["parentKey"];
        this.$store.dispatch('Homepage/createFinalStore', formData).then((json)=>{
            if(json.status != 200){
            alert(json.message)
          }else{
            // this.$store.dispatch('Homepage/getStoreList',this.pagination);
            this.$refs.storeList.search(this.pagination)
            this.storeForm = storeFormInitial;
            this.modalShow = false;          
            }
        })
      }

    },
    createMerchant(){
      if(confirm(`確認新增商戶${this.merchantForm.username}?`)){
        this.$store.dispatch('Homepage/createMerchant', this.merchantForm).then((json)=>{
            this.getMerchantList();
            this.showCreateMerchant = false;
            this.merchantForm.username = '';  
       
        });
      }
    },
    getMerchantList(){
        let merchantList = [];
        this.$store.dispatch('Homepage/getMerchantList',{type:'store'}).then((json)=>{
        json.data.list
          .forEach((user) => {
            merchantList.push({value:user.username, text:user.username});
          })
      });
        this.merchantList = merchantList;
        // console.log(this.merchantList);

    },
    getImageUrl(row){
      let imageDomain = process.env.DOMAIN + "/"; // production
      // let imageDomain = "https://test.tarvel.co/biotrue/rest/";  // Development
      // console.log(row);
      return imageDomain + row;
    },
    createCSV(){
      this.$store.dispatch('Homepage/exportFinalStore',{key:'exportFinalStore', code: '2SF945XC!@SDF34'});
    },
    redeemRecord(ID,status){

      if(status == 'Y'){
        alert("該推廣優惠碼已兌換");
        return;
      }

      if(!confirm("確認兌換該用戶的推廣優惠碼？")){
        return ;
      }

      if(!ID){
        return;
      }
      this.$store.dispatch('Homepage/redeemBIRecord',{'ID':ID})
      .then((json) => {
        this.$refs.storeList.search(this.pagination);
      });


    },
    deleteRecord(ID,status){
        if(!confirm("確認修改此店舖記錄狀態？")){
        return ;
      }
      if(!ID){
        return;
      }
      this.$store.dispatch('Homepage/deleteFinalStore',{'ID':ID, version:status})
      .then((json) => {
        this.$refs.storeList.search({ page: 1, count: 100 });
      });

    },
    getSubDegree( parentKey,value ){

      let degree = "";
        $.each(this.selections.degree, (index,item)=>{
        if  ((item.parentKey == parentKey)&&(item.value == value)){
          degree = item.text;
        }   
      });

      return degree;
    },

  }
}

</script>



// WEBPACK FOOTER //
// src/Homepage/components/Registration/SMSBatch.vue